import React from 'react';

interface PageHeaderProps {
  title: string;
  subtitle: string;
  dataUpdatedAt: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  dataUpdatedAt,
}) => {
  return (
    <header className="mb-[10px] flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
      <div>
        <div className="flex items-center gap-2 text-[17px] font-semibold text-[#0f172a]">
          <span aria-hidden="true">📊</span>
          <span>{title}</span>
        </div>
      </div>
      <div className="text-left text-[11px] leading-[1.5] text-[#94a3b8] md:text-right">
        {/* <div>{subtitle}</div>
        <div>{`数据更新于 ${dataUpdatedAt}`}</div> */}
      </div>
    </header>
  );
};

export default PageHeader;
